import React, { useEffect, useState } from "react";
import { ClickableComponent } from "./components/Dashboard/ClickableComponent";
import {
  ArchiveBoxIcon,
  EyeIcon,
  MicrophoneIcon,
  StarIcon,
  ArrowUpCircleIcon,
} from "@heroicons/react/24/solid";
import { TargetIcon } from "lucide-react";
import UserProfile from "./components/UserProfile";
import { useAuth } from "./context/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import SubscriptionBadge from "./components/SubscriptionBadge";
import api from "./services/api";

export default function Dashboard() {
  const { user, isPremiumUser } = useAuth();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const navigate = useNavigate();
  useEffect(() => {
    const planId = localStorage.getItem("selected_plan_id");
    const isAnnual = localStorage.getItem("selected_plan_annual");

    console.log("Plan ID:", planId);
    console.log("Is Annual:", isAnnual);

    console.log("User:", user);
    if (user?.is_premium !== "active" && user?.is_premium !== "trialing") {
      if (planId && isAnnual) {
        const createCheckoutSession = async () => {
          try {
            // Call the backend to create a checkout session using api service
            const response = await api.post(
              "/api/payment/create-checkout-session",
              {
                plan_id: planId,
                is_annual: isAnnual || false,
              }
            );

            const { url } = response.data;

            // Redirect to checkout page with the client secret
            // navigate(`/checkout?client_secret=${client_secret}`);
            localStorage.removeItem("selected_plan_id");
            localStorage.removeItem("selected_plan_annual");
            window.location.href = url;
          } catch (error) {
            navigate("/pricing");
            console.error("Error creating checkout session:", error);
          }
        };
        createCheckoutSession();
      } else {
        navigate("/pricing");
      }
    }
    setIsLoading(false);
  }, []);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-8">
        <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-blue-500"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white dark:bg-gray-950 transition-colors duration-200">
      <div className="pt-4 px-4">
        {/* <UserProfile /> */}

        {/* Subscription banner */}

        {/* Premium plan banner */}
        {user && isPremiumUser() && (
          <div className="mb-6 p-4 rounded-lg bg-green-50 border border-green-200">
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between">
              <div className="text-green-800 font-medium">
                <span>You have a premium plan 🎉</span>
              </div>

              <SubscriptionBadge />
            </div>
          </div>
        )}

        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
          Let's Get Started!
        </h1>
        <p className="text-gray-500 dark:text-gray-400">
          What would you like to create today?
        </p>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 lg:w-4xl 2xl:w-6xl 2xl:grid-cols-4 gap-x-4 mt-4 mx-4">
        <ClickableComponent
          title="Product Talking Videos"
          description="Upload a product image and get a video of someone holding and talking about it."
          image="/productvideos.png"
          outside={true}
          icon={<ArchiveBoxIcon className="w-7 h-7 text-white" />}
          iconBg="violet"
          link="/product-videos"
        />
        <ClickableComponent
          title="Talking Videos"
          description="Get a UGC video of someone talking without the product in hand."
          image="/b.png"
          outside={false}
          icon={<MicrophoneIcon className="w-7 h-7 text-white" />}
          iconBg="blue"
          link="/talking-videos"
        />
        {/* <ClickableComponent
          title="Hook Videos"
          description="Create 1-3 second headshot videos of real people to instantly hook viewers."
          image="/c.png"
          outside={false}
          icon={<TargetIcon className="w-7 h-7 text-white" />}
          iconBg="green"
          link="/generate-video"
        />
        <ClickableComponent
          title="Custom Avatars"
          description="Prompt our AI to create any person for use in your hook videos."
          image="/d.png"
          outside={false}
          icon={<TargetIcon className="w-7 h-7 text-white" />}
          iconBg="indigo"
          link="/generate-video"
        />
        <ClickableComponent
          title="Review Images"
          description="Generate headshot images of people holding products for authentic reviews."
          image="/e.png"
          outside={false}
          icon={<StarIcon className="w-7 h-7 text-white" />}
          iconBg="orange"
          link="/generate-video"
        />
        <ClickableComponent
          title="Slideshows"
          description="Create social media slideshow posts in seconds. Blah blah blah blah."
          image="/e.png"
          outside={false}
          icon={<EyeIcon className="w-7 h-7 text-white" />}
          iconBg="cyan"
          link="/generate-video"
        /> */}
      </div>
    </div>
  );
}
